// set the dates for the upcoming showcase and application deadline across the website

export const today = new Date();
// April 23, 2025 (month index starts with 0: January = 0, February = 1, etc.)
export const showcaseDate = new Date(2025, 6, 16);
// April 4, 2025
export const showcaseApplicationDeadlineDate = new Date(2025, 6, 7);

const todayStr = today.toISOString().split("T")[0]; // "2025-06-01"
const showcaseStr = showcaseDate.toISOString().split("T")[0]; // "2025-04-23"
export let upcomingShowcase = todayStr < showcaseStr;

export function formatDate(date) {
  const options = { month: "long", day: "2-digit", year: "numeric" };
  const formatted = date.toLocaleDateString("en-US", options);
  const [month, day, year] = formatted.replace(",", "").split(" ");
  const result = `${month} ${day}, ${year}`;
  return result;
}

export function formatDateWeekday(date) {
  const options = {
    weekday: "long",
    month: "long",
    day: "2-digit",
    year: "numeric",
  };

  const formatted = date.toLocaleDateString("en-US", options);
  const [weekday, month, day, year] = formatted.replace(",", "").split(" ");
  const result = `${weekday}, ${month} ${day} ${year}`;
  return result;
}
